import { render, staticRenderFns } from "./CommunityQna.vue?vue&type=template&id=37bd18c0&scoped=true"
import script from "./CommunityQna.vue?vue&type=script&lang=js"
export * from "./CommunityQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd18c0",
  null
  
)

export default component.exports